module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/EOdcId/tc-custom/9781488042218.jpg?1700293122248",
      "alt": "This image is the cover for the book Marine's Family Mission, Camden Family Secrets"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Marine's Family Mission, Camden Family Secrets\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Of all the people who had come to give condolences for her brother-in-law, it had to be him. A poignant romance from the "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author.")]), _c('br'), _c('br'), _vm._v("Four years ago, Declan Madison rescued Emmy Tate from a bombed Afghan school—and brutally dismissed their instant attraction. Now he’s back in her life, watchful of the two orphaned kids Emmy’s raising. Declan can’t bring back his best friend, but playing family with the beautiful photographer is the next best thing. If only they didn’t share so much past trauma . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Victoria Pade\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Victoria Pade is a USA Today bestselling author of multiple romance novels.  She has two daughters and is a native of Colorado, where she lives and writes.  A devoted chocolate-lover, she's in search of the perfect chocolate chip cookie recipe.  Readers can find information about her latest and upcoming releases by logging on to "), _c('a', {
    attrs: {
      "href": "http://www.vikkipade.com"
    }
  }, [_vm._v("www.vikkipade.com")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0